<template>
  <vue-modal name="CreateTask" :hideCloseBtn="true" :width="width">
    <!-- :onShow="changeForm()" -->
    <QrCode
      ref="QrCodeCrTask"
      :name="qrName"
      :photo="photomode"
      @onPhoto="getCamResCh"
    />
    <modalImg ref="imgzoomC2" :name="modalImgname" :arrImg="modalArr" />

    <div class="card mb-0" style="border: none; box-shadow: none">
      <div class="card-header" style="border-bottom: none; padding: 1rem 0px">
        <h3 class="form-section">
          <i class="icon-plus2"></i> {{ $t("tasks.titles.newTask") }}
        </h3>
        <div class="heading-elements" style="right: 0px">
          <button
            type="button"
            class="btn btn-warning"
            @click="
              clearData();
              $modals.hide('CreateTask');
            "
          >
            <i style="color: #ffffff" class="icon-cross"></i>
          </button>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-0">
              <h5>{{ $t("tasks.eqMethod.title") }}</h5>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="row pl-1 pr-1">
              <div class="form-group" v-if="lenSerials > 0">
                <span
                  v-for="(serial, index) in newTask.serials"
                  :key="index"
                  class="btn tag-default btn-warning"
                  style="margin: 0.2rem"
                >
                  {{ serial.serial }}
                </span>
              </div>
            </div>

            <div class="mb-1">
              <div class="input-group">
                <div
                  class="form-control border-primary"
                  style="background-color: #eceeef"
                  :class="{ 'border-danger': $v.newTask.priority.$error }"
                  id="typeFltr"
                  @click="chPrior = !chPrior"
                >
                  {{ choosPriorTitle }}
                </div>
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-primary btn-round"
                    @click="chPrior = !chPrior"
                  >
                    <a class="dropdown-toggle" style="color: white"></a>
                  </button>
                </div>
                <div
                  class="dropdown-menu"
                  v-if="chPrior"
                  @mouseleave="chPrior = false"
                >
                  <button
                    v-for="(item, index) in $store.state.priority"
                    :key="index"
                    class="dropdown-item"
                    :class="
                      'btn-' + $t('priority.statuses.' + item.id + '.class')
                    "
                    type="button"
                    @click="
                      newTask.priority = item.id;
                      chPrior = !chPrior;
                    "
                  >
                    {{ $t("priority.statuses." + item.id + ".word") }}
                  </button>
                </div>
              </div>
              <span v-if="$v.newTask.priority.$error" style="color: red">
                <span class="d-flex" v-if="!$v.newTask.priority.required">{{
                  $t("errors.required")
                }}</span>
              </span>
            </div>

            <div class="mb-1">
              <div class="input-group">
                <div
                  class="form-control border-primary"
                  style="background-color: #eceeef"
                  :class="{ 'border-danger': $v.newTask.typeT.$error }"
                  id="typeFltr"
                  @click="chType = !chType"
                >
                  {{ choosTypeTitle }}
                </div>
                <div class="input-group-append">
                  <button
                    type="button"
                    class="btn btn-primary btn-round"
                    @click="chType = !chType"
                  >
                    <a class="dropdown-toggle" style="color: white"></a>
                  </button>
                </div>
                <div
                  class="dropdown-menu"
                  v-if="chType"
                  @mouseleave="chType = false"
                >
                  <button
                    v-for="(task, index) in $store.state.typesTask"
                    :key="index"
                    class="dropdown-item"
                    type="button"
                    @click="
                      newTask.typeT = task;
                      chType = !chType;
                    "
                  >
                    {{ $t(task.text) }}
                  </button>
                </div>
              </div>
              <span v-if="$v.newTask.typeT.$error" style="color: red">
                <span class="d-flex" v-if="!$v.newTask.typeT.required">{{
                  $t("errors.required")
                }}</span>
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group position-relative has-icon-left">
              <textarea
                id="comment"
                rows="3"
                class="form-control border-primary"
                name="comment"
                :class="{ 'border-danger': $v.newTask.jobs.$error }"
                :placeholder="$t('tasks.table.jobs')"
                v-model.trim="$v.newTask.jobs.$model"
              ></textarea>
              <div class="form-control-position">
                <i class="icon-stack"></i>
              </div>
              <span v-if="$v.newTask.jobs.$error" style="color: red">
                <span class="d-flex" v-if="!$v.newTask.jobs.required">{{
                  $t("tasks.errors.jobs")
                }}</span>
                <span class="d-flex" v-if="!$v.newTask.jobs.minLength"
                  >{{ $t("errors.minLength") }}
                  {{ $v.newTask.jobs.$params.minLength.min }}</span
                >
              </span>
            </div>

            <div class="">
              <div class="form-group">
                <div class="position-relative has-icon-left">
                  <input
                    type="text"
                    id="address"
                    :placeholder="$t('equipm.table.location')"
                    name="address"
                    class="form-control border-primary"
                    v-model.trim="$v.newTask.address.$model"
                    :class="{ 'border-danger': $v.newTask.address.$error }"
                  />
                  <div class="form-control-position">
                    <i class="icon-location-arrow"></i>
                  </div>
                </div>
                <span v-if="$v.newTask.address.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.newTask.address.required">{{
                    $t("tasks.errors.address")
                  }}</span>
                  <span class="d-flex" v-if="!$v.newTask.address.minLength"
                    >{{ $t("errors.minLength") }}
                    {{ $v.newTask.address.$params.minLength.min }}</span
                  >
                </span>
              </div>
            </div>

            <!-- <div class="form-group">
                                <textarea id="comment" rows="3" class="form-control border-primary" name="comment" :placeholder="$t('tasks.table.comment')" v-model="newTask.comment"></textarea>
                            </div> -->
          </div>
        </div>

        <div class="row" v-if="newTask.categories.length > 0">
          <div class="col-md-12">
            <div class="form-group mb-0">
              <h5>{{ $t("problem.table.probl_categ") }}</h5>
            </div>
          </div>

          <div
            class="col-md-3"
            v-for="(gr, ind) in newTask.categories"
            :key="ind"
          >
            <div
              v-for="(ch, index) in gr"
              :key="index"
              class="hand"
              @click="ch.checked = !ch.checked"
              style="margin: 10px 5px 10px 5px"
            >
              <i
                :class="[
                  ch.checked
                    ? 'icon-checkbox-checked'
                    : 'icon-checkbox-unchecked',
                ]"
                style="vertical-align: middle"
              ></i>
              <i
                style="vertical-align: middle; margin-left: 5px"
                class="font-large-1"
                :class="ch.class"
              ></i>
              <span
                style="
                  vertical-align: middle;
                  font-size: 1.3em;
                  max-width: 80%;
                  margin-left: 5px;
                "
              >
                {{ $t(ch.title) }}</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <!-- <div class="mobileTbl table-responsive mb-1">
                                <table class="table table-hover mb-0" cellspacing="0">
                                    <thead>
                                        <tr>
                                            <th style="vertical-align: middle;">{{$t('equipm.table.country')}}</th>
                                            <th style="vertical-align: middle;">{{$t('equipm.table.region')}}</th>
                                            <th style="vertical-align: middle;">{{$t('equipm.table.city')}}</th>
                                            <th style="vertical-align: middle;">{{$t('equipm.table.street')}}</th>
                                            <th style="vertical-align: middle; width: 8%">{{$t('equipm.table.number')}}</th>
                                            <th style="vertical-align: middle; width: 10%">{{$t('equipm.table.index')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td :data-title="$t('equipm.table.country')">
                                                <input type="text" id="country" class="form-control" name="country" v-model="newTask.addressT.country" >
                                            </td>
                                            <td :data-title="$t('equipm.table.region')">
                                                <input type="text" id="region" class="form-control" name="region" v-model="newTask.addressT.region" >
                                            </td>
                                            <td :data-title="$t('equipm.table.city')">
                                                <input type="text" id="city" class="form-control" name="city" v-model="newTask.addressT.city" >
                                            </td>
                                            <td :data-title="$t('equipm.table.street')">
                                                <input type="text" id="street" class="form-control" name="street" v-model="newTask.addressT.street" >
                                            </td>
                                            <td :data-title="$t('equipm.table.number')" style="width: 8%">
                                                <input type="text" id="streetN" class="form-control" name="streetN" v-model="newTask.addressT.streetN">
                                            </td>
                                            <td :data-title="$t('equipm.table.index')" style="width 10%">
                                                <input type="text" id="index" class="form-control" name="index" v-model="newTask.addressT.index" @keypress="isNumber($event)">
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> -->

            <div class="">
              <form class="form">
                <h4 class="form-section">
                  <i class="icon-images2"></i> {{ $t("tasks.table.images") }}
                </h4>

                <div class="form-group mb-0">
                  <input
                    type="file"
                    name="file"
                    id="file"
                    class="inputfile"
                    multiple="multiple"
                    accept="image/x-png,image/jpeg"
                    @change="onUploadImg"
                  />
                  <label id="file_loader" for="file">
                    <a class="btn btn-primary btn-min-width"
                      ><i class="icon-upload3"></i>
                      {{ $t("tasks.buttons.file") }}</a
                    >
                  </label>
                  <button
                    type="button"
                    class="btn btn-warning"
                    @click="
                      photomode = true;
                      showCam();
                    "
                    data-html="true"
                    :title="$t('equipm.hint.camera')"
                  >
                    <i style="color: #ffffff" class="icon-camera8"></i>
                    {{ $t("tasks.buttons.photo") }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="
                      newTask.images = [];
                      newTask.images2 = [];
                    "
                    v-if="newTask.images.length > 0"
                  >
                    <i class="icon-bin"></i> {{ $t("tasks.buttons.remove") }}
                  </button>
                </div>
                <span
                  style="color: red"
                  class="d-flex mt-1"
                  v-if="$v.newTask.images.$error"
                  >{{ $t("errors.filesEmpty") }}</span
                >

                <div class="row mt-1">
                  <div class="col-md-12" style="display: flex; flex-wrap: wrap">
                    <div
                      class="col-xs-3"
                      style="
                        padding: 0;
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        margin-bottom: 1em;
                      "
                      v-for="(image, index) in newTask.images"
                      :key="index"
                    >
                      <div class="card hand mb-0" style="margin-left: 5px">
                        <div class="w-100 h-100">
                          <i
                            class="icon-cross delete-image-icon"
                            @click="
                              newTask.images.splice(index, 1);
                              newTask.images2.splice(index, 1);
                            "
                          ></i>
                          <img
                            v-bind:src="image.data"
                            style="max-width: 100%; max-height: 100%"
                            @click="expandDiv(newTask.images, index)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="d-flex" style="justify-content: flex-end">
          <button
            type="button"
            class="btn btn-success"
            @click="createTask()"
            v-if="!$store.state.listRole.service"
          >
            <i style="color: #ffffff" class="icon-check"></i>
            {{ $t("tasks.buttons.create") }}
          </button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";

export default {
  name: "ModalTaskCreate",
  data() {
    return {
      width: null,
      modalImgname: "modalImg2",
      qrName: "QrCode2",

      chPrior: false,
      chType: false,
      newTask: {
        serial: null, //"ме-20123469393"
        serials: [],
        comment: null,
        typeT: null,
        address: null,
        addressT: {
          country: null,
          region: null,
          city: null,
          street: null,
          streetN: null,
          index: null,
        },
        jobs: null,
        priority: null,
        images: [],
        images2: [],
        categories: [],
        checks: [],

        checkAddress: false,
      },
      filesLimit: 24,
      modalArr: [],

      photomode: true,

      position: {
        latitude: null,
        longitude: null,
        accuracy: null,
      },
    };
  },
  validations: {
    newTask: {
      jobs: { required, minLength: minLength(4) },
      address: { required, minLength: minLength(4) },
      typeT: { required },
      priority: { required },
      images: { required, minLength: minLength(1), $each: { required } },
    },
  },
  components: {},
  props: {
    guid: { required: false, type: String, default: "" },
    serials: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    comment: { required: false, type: String, default: "" },
    checks: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
    address: { required: false, type: String, default: "" },
    images: {
      required: false,
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  emits: ["onClose"],
  methods: {
    changeForm() {
      //document.getElementsByClassName('v-modal__heading').style.padding = '0px';
      setTimeout(() => {
        $(".v-modal__heading").css({ padding: "0px" });
      }, 800);
    },
    clearData() {
      this.newTask.serial = null;
      this.newTask.serials = [];
      this.newTask.comment = null;
      this.newTask.typeT = null;
      this.newTask.address = null;
      this.newTask.jobs = null;
      this.newTask.priority = null;
      this.newTask.images = [];
      this.newTask.images2 = [];
      this.newTask.categories = [];
      this.newTask.temp_checks = [];

      this.position.latitude = null;
      this.position.longitude = null;
      this.position.accuracy = null;

      this.newTask.checkAddress = false;

      this.$v.newTask.typeT.$reset();
      this.$v.newTask.priority.$reset();
      this.$v.newTask.jobs.$reset();
      this.$v.newTask.typeT.$reset();
      this.$v.newTask.address.$reset();
      this.$v.newTask.images.$reset();
    },
    expandDiv(arr, ind) {
      if (arr[0].data != undefined) {
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          arr2.push(arr[i].data);
        }
        arr = arr2;
      }

      $("#" + this.modalImgname).modal("show");
      this.$refs.imgzoomC2.onShow(ind, arr);
    },
    showCam() {
      this.$refs.QrCodeCrTask.changeForm();
      this.$modals.show(this.qrName);
    },
    onUploadImg(e) {
      let tt = null;
      let _this = this;
      if (e.target.files.length > 0) {
        for (let i = 0; i < e.target.files.length; i++) {
          const element = e.target.files[i];
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = (e) => {
            var img = new Image();
            img.onload = function () {
              if (img.width > 1500) {
                //зжимання
                var w = img.width;
                var h = img.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d"); // Создаем узел атрибута
                var anw = document.createAttribute("width");
                anw.nodeValue = w;
                var anh = document.createAttribute("height");
                anh.nodeValue = h;
                canvas.setAttributeNode(anw);
                canvas.setAttributeNode(anh);
                ctx.drawImage(img, 0, 0, w, h);
                // Чем меньше значение .7, тем более размытым будет нарисованное изображение
                var base64Img = canvas.toDataURL("image/jpeg", 0.6);
                //зжимання

                tt = base64Img.split(",");
              } else {
                tt = img.src.split(",");
              }

              let err = false;
              if (_this.newTask.images.length < _this.filesLimit) {
                _this.newTask.images.push({
                  name: "newTask_" + Math.floor(Math.random() * 4999) + ".png",
                  data: tt[0] + "," + tt[1],
                });
                _this.newTask.images2.push({
                  name: "newTask_" + Math.floor(Math.random() * 4999) + ".png",
                  data: tt[1],
                });
              } else {
                err = true;
              }

              if (err) {
                _this.$notify({
                  group: "info",
                  title: "Warning",
                  text: "Ліміт файлів " + _this.filesLimit + 1,
                });
              }
            };
            img.src = e.target.result;
          };
        }
      }
    },
    getCamResCh(dataCam) {
      if (this.isValid(dataCam)) {
        let name = "newTask_" + Math.floor(Math.random() * 4999) + ".png";
        this.newTask.images.push({ name: name, data: dataCam });
        this.newTask.images2.push({ name: name, data: dataCam.split(",")[1] });
      }
    },
    getQRSerialCh(event, serial) {
      this.addSerial({ serial: serial, address: null });
    },
    createTask() {
      if (this.newTask.serials.length < 1) {
        this.clearData();
        this.$modals.hide("CreateTask");
        return;
      }

      this.$v.newTask.typeT.$touch();
      this.$v.newTask.priority.$touch();
      this.$v.newTask.jobs.$touch();
      this.$v.newTask.typeT.$touch();
      this.$v.newTask.address.$touch();
      this.$v.newTask.images.$touch();

      if (
        !this.$v.newTask.typeT.$error &&
        !this.$v.newTask.priority.$error &&
        !this.$v.newTask.jobs.$error &&
        !this.$v.newTask.typeT.$error &&
        !this.$v.newTask.address.$error &&
        !this.$v.newTask.images.$error
      ) {
        this.$v.newTask.typeT.$reset();
        this.$v.newTask.priority.$reset();
        this.$v.newTask.jobs.$reset();
        this.$v.newTask.typeT.$reset();
        this.$v.newTask.address.$reset();
        this.$v.newTask.images.$reset();

        let checks = [];
        if (this.newTask.categories.length > 0) {
          for (let i = 0; i < this.newTask.categories.length; i++) {
            for (let j = 0; j < this.newTask.categories[i].length; j++) {
              if (this.newTask.categories[i][j].checked) {
                checks.push(this.newTask.categories[i][j].guid);
              }
            }
          }
        }
        let images = [],
          images2 = [],
          links = [];
        if (this.newTask.images.length > 0) {
          let data;
          for (let i = 0; i < this.newTask.images.length; i++) {
            if (typeof this.newTask.images[i].data == "string") {
              if (
                this.newTask.images[i].data.indexOf("/preview") > -1 &&
                this.newTask.images[i].data.indexOf("http") > -1
              ) {
                data = this.newTask.images[i].data.split("/preview")[0];
                links.push({ data: data, name: this.newTask.images[i].name });
              } else {
                images.push({
                  data: this.newTask.images[i].data,
                  name: this.newTask.images[i].name,
                });
                images2.push({
                  data: this.newTask.images2[i].data,
                  name: this.newTask.images[i].name,
                });
              }
            }
          }
        }

        let dataRequest = {
          login: this.$store.state.user,
          email: this.$store.state.email,
          type: this.newTask.typeT.val,
          serial: this.newTask.serials,
          comment: this.newTask.comment,
          jobs: this.newTask.jobs,
          guidClient: this.$store.state.guidClient,
          linksImages: links,
          arrayImage: images,
          arrayImage2: images2,
          position: this.position,
          address: this.newTask.address,
          priority: this.newTask.priority,
          guidProblem: this.guid,
          categories: checks,
          /*address: {
                        country : this.newTask.addressT.country,
                        region: this.newTask.addressT.region,
                        city: this.newTask.addressT.city,
                        street: this.newTask.addressT.street,
                        streetN: this.newTask.addressT.streetN,
                        index: this.newTask.addressT.index
                    },*/
        };

        this.makeQuery("/service/createtask", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            /*let reklamation = ["000000007", "000000008"];
            if (
              result &&
              typeof result === "string" &&
              dataRequest.type &&
              reklamation.includes(dataRequest.type)
            ) {
              dataRequest.taskNumber = result;
              this.makeQuery2(
                "/bitrixErp/hs/Upp/Upp_create",
                dataRequest,
                "https://bitrixerp.modern-expo.com"
              )
                .then((result2) => {
                  if (result2 && result2.status) {
                    this.showNotification(
                      "custom-success",
                      "Success",
                      this.$t("tasks.titles.taskOtherCreated"),
                      -1
                    );
                  } else {
                    this.showNotification(
                      "custom-error",
                      this.$t("tasks.titles.taskOtherFail"),
                      result2
                    );
                  }

                  this.clearData();
                  this.$emit("onClose", result2);
                  this.$modals.hide("CreateTask");
                })
                .catch((result2) => {
                  this.showNotification(
                    "custom-error",
                    this.$t("tasks.titles.taskOtherFail"),
                    result2
                  );
                  this.clearData();
                  this.$emit("onClose", { result: true });
                  this.$modals.hide("CreateTask");
                });
            } else {
              this.showNotification(
                "custom-success",
                "No number of task",
                this.$t("tasks.titles.created"),
                -1
              );
              this.clearData();
              this.$emit("onClose", { result: true });
              this.$modals.hide("CreateTask");
            }*/

            this.showNotification(
              "custom-success",
              result ? result : "No number of task",
              this.$t("tasks.titles.created"),
              -1
            );
            this.clearData();
            this.$emit("onClose", { result: true });
            this.$modals.hide("CreateTask");
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      }
    },
    addSerial(payload) {
      let ps = payload;
      if (this.isValid(payload.serial)) {
        let ser = this.checkPattSer(ps.serial);
        if (ser) {
          ps.serial = ser;
        } else {
          this.newTask.serial = null;
          return;
        }

        let ind_find = null;
        for (let i = 0; i < this.lenSerials.length; i++) {
          if (ps.serial == this.newTask.serials[i].serial) {
            //serial
            ind_find = i;
            break;
          }
        }

        if (ind_find == null) {
          this.newTask.serials.push(ps);
        }
        this.newTask.serial = null;
      }
    },
    checkAddresses() {
      if (this.lenSerials > 1 && this.newTask.checkAddress == false) {
        setTimeout(() => {
          let addr = this.newTask.serials[0].address.substring(0, 10);
          for (let i = 1; i < this.lenSerials; i++) {
            if (this.newTask.serials[i].address.indexOf(addr) < 0) {
              this.showNotification(
                "custom-info",
                this.$t("tasks.titles.newTask"),
                this.$t("tasks.errors.adressNTask")
              );
              this.newTask.address = this.newTask.serials[0].address;
              this.newTask.checkAddress = true;
              break;
            }
          }
          this.newTask.address = this.newTask.serials[0].address;
        }, 500);
      } else if (this.lenSerials == 1) {
        this.newTask.address = this.newTask.serials[0].address;
      }
    },
    firstRun() {
      setTimeout(() => {
        $(".v-modal__heading").css({ padding: "0px" });
        $(".v-modal__mask").css({ "overflow-y": "auto" });
      }, 800);

      this.clearData();

      if (this.comment) {
        this.newTask.jobs = this.comment;
      }
      if (this.checks.length > 0) {
        for (let i = 0; i < this.checks.length; i++) {
          this.newTask.checks.push(this.checks[i]);
        }
      }

      if (this.address) {
        this.newTask.address = this.address;
      }

      if (this.serials.length > 0) {
        this.serials.forEach((element, i) => {
          setTimeout(() => {
            this.addSerial({ serial: element, address: null });
          }, 1000 * ++i);
        });
      }
      if (this.images.length > 0) {
        let nameF = "";
        for (let i = 0; i < this.images.length; i++) {
          nameF = "newTask_" + Math.floor(Math.random() * 4999) + ".png";
          this.newTask.images.push({ data: this.images[i], name: nameF });
          this.newTask.images2.push({ data: this.images[i], name: nameF });
        }
      }

      this.getGPS()
        .then((result) => {
          this.position.latitude = result.latitude;
          this.position.longitude = result.longitude;
          this.position.accuracy = result.accuracy;
        })
        .catch((err) => {
          this.showNotification("custom-error", "Geolocation", err.message);
        });
    },
    getListCategories(guidEq) {
      let categories = [];

      return new Promise((resolve, reject) => {
        let dataRequest = {
          guid: guidEq,
        };
        this.makeQuery("/service/getListProblemEquipment", {
          dataRequest: dataRequest,
          token: this.$store.getters.getUserToken,
        })
          .then((result) => {
            for (let i = 0; i < result.length; i++) {
              for (let j = 0; j < this.$store.state.categories.length; j++) {
                if (
                  parseFloat(result[i].icon) ==
                  this.$store.state.categories[j].id
                ) {
                  categories.push({
                    id: this.$store.state.categories[j].id,
                    guid: result[i].guid,
                    title: this.$store.state.categories[j].title,
                    class: this.$store.state.categories[j].class,
                    checked: false,
                  });
                  break;
                }
              }
            }
            return resolve(categories);
          })
          .catch((result) => {
            this.showNotification("custom-error", "Error", result);
          });
      });
    },
  },
  computed: {
    choosPriorTitle: function () {
      if (this.newTask.priority == null) {
        return this.$t("priority.titles.empty");
      } else {
        return this.$t("priority.statuses." + this.newTask.priority + ".word");
      }
    },
    choosTypeTitle: function () {
      if (this.newTask.typeT == null) {
        return this.$t("tasks.table.deffType");
      } else {
        return this.$t(this.newTask.typeT.text);
      }
    },
    lenSerials() {
      return this.newTask.serials.length;
    },
  },
  mounted() {},
  watch: {
    "dataEquipment.tabs.info": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.files = false;
        this.dataEquipment.tabs.history = false;
      }
    },
    "dataEquipment.tabs.photo": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.files = false;
        this.dataEquipment.tabs.history = false;

        this.loadPictures();
      }
    },
    "dataEquipment.tabs.files": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.history = false;

        //this.loadInstructions();
      }
    },
    "dataEquipment.tabs.history": function (newVal, oldVal) {
      if (oldVal == false && newVal == true) {
        this.dataEquipment.tabs.info = false;
        this.dataEquipment.tabs.photo = false;
        this.dataEquipment.tabs.files = false;

        if (this.dataEquipment.history.length < 1) {
          this.loadHistory();
        }
      }
    },
    lenSerials: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value > 0) {
          if (this.newTask.serials[value - 1].address == null) {
            let dataRequest = {
              serial: this.newTask.serials[value - 1].serial,
              userGuid: this.$store.getters.getGuidUser,
            };
            this.makeQuery("/service/productSerial", {
              dataRequest: dataRequest,
              token: this.$store.getters.getUserToken,
            })
              .then((result) => {
                if (result.GUID != undefined) {
                  if (result.Adress != undefined) {
                    this.newTask.serials[value - 1].address = result.Adress;
                    this.checkAddresses();
                  }
                }
              })
              .catch((result) => {
                this.showNotification("custom-error", "Error", result);
              });
          } else {
            this.checkAddresses();
          }
        } else if (value < 1) {
          this.newTask.address = null;
          this.newTask.checkAddress = false;
        }
      },
      /*
                this.newTask.categories = [];
                this.getListCategories(result.GUID)
                .then(result => {
                    let checker = 0;
                    if(result.length > 0){
                        this.newTask.categories.push([]);

                        for (let j = 0; j < result.length; j++) {
                            for (let i = 0; i < this.newTask.checks.length; i++) {
                                if(this.newTask.checks[i].id == result[j].id){
                                    result[j].checked = true;
                                    break
                                }
                            }
                            if(this.newTask.categories[checker].length < 4){
                                this.newTask.categories[checker].push(result[j]);
                            } else {
                                checker = checker + 1;
                                this.newTask.categories.push([]);
                                this.newTask.categories[checker].push(result[j]);
                            }
                            
                        }
                    } else if(this.newTask.checks.length > 0){
                        this.newTask.categories.push([]);

                        for (let j = 0; j < this.newTask.checks.length; j++) {
                            
                            if(this.newTask.categories[checker].length < 4){
                                this.newTask.categories[checker].push(this.newTask.checks[j]);
                            } else {
                                checker = checker + 1;
                                this.newTask.categories.push([]);
                                this.newTask.categories[checker].push(this.newTask.checks[j]);
                            }
                            
                        }
                    }
                });*/
    },
  },
  created() {
    this.width = window.innerWidth * 0.8;
    $(".v-modal__heading").css({ padding: "0px" });
    $(".v-modal__mask").css({ "overflow-y": "auto" });
  },
};
</script>

<style scoped>
.border-danger {
  border: 3px solid #da4453 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ModalTaskCreate.vue